// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invoice-currency-type[data-v-2197b83a] {\n  background-color: #f5f5f5;\n  color: rgba(0,0,0,.88);\n  margin: 0;\n  padding: 11px 10px;\n  border-radius: 8px 0px 0px 8px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: 0em;\n}\n", ""]);
// Exports
module.exports = exports;
